import { inject, Injector } from '@angular/core';
import { LoggerService } from '@core/services/logger.service';

/**
 * Logger helper - Wrapper để dùng logger dễ dàng hơn
 * Có thể dùng trong components, services, guards, interceptors...
 */
export class LOGGER {
  private static injector: Injector | null = null;
  private static service: LoggerService | null = null;

  // ✅ Initialize injector từ AppComponent hoặc main.ts
  static setInjector(injector: Injector): void {
    this.injector = injector;
  }

  // ✅ Lazy init service từ injector
  private static getService(): LoggerService {
    if (!this.service && this.injector) {
      this.service = this.injector.get(LoggerService);
    }
    return this.service || new LoggerService(); // Fallback
  }

  static debug(...args: any[]): void {
    this.getService().debug(...args);
  }

  static info(...args: any[]): void {
    this.getService().info(...args);
  }

  static warn(...args: any[]): void {
    this.getService().warn(...args);
  }

  static error(...args: any[]): void {
    this.getService().error(...args);
  }

  static group(label: string, callback: () => void): void {
    console.group(label);
    callback();
    console.groupEnd();
  }

  static table(data: any): void {
    this.getService().table(data);
  }
}

// ✅ Sử dụng
// Logger.info('User logged in');
// Logger.error('API error:', error);
